import { create } from 'zustand';
import { LocalStorageUtils } from '@shared';
import { ApiUtils, type Partner, ProductApi, RequestStrategyEnum } from '@shared/api';

interface IPartnersStore {
  loading: boolean;
  error: string | null;
  partners: Partner[] | null;
  selectedPartnerId: number | null;
  getPartners: (signal?: AbortSignal) => Promise<void>;
  setPartners: (partners: Partner[]) => void;
  setSelectedPartnerId: (id: number) => void;
  clear: () => void;
}

export const usePartnersStore = create<IPartnersStore>((set, get) => ({
  loading: false,
  error: null,
  partners: LocalStorageUtils.getPartners(),
  selectedPartnerId: LocalStorageUtils.getSelectedPartnerId(),

  getPartners: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProductApi.getPartners(signal);
      LocalStorageUtils.setPartners(result);

      let selectedPartnerId = get().selectedPartnerId || 0;
      if (!selectedPartnerId || !result?.some((item) => item.id === selectedPartnerId)) selectedPartnerId = result[0]?.id;
      if (selectedPartnerId) LocalStorageUtils.setSelectedPartnerId(selectedPartnerId);

      set({ partners: result ?? null, selectedPartnerId: selectedPartnerId ?? get().selectedPartnerId, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  setPartners: (partners) => set(() => ({ partners })),

  setSelectedPartnerId: (id) => set(() => ({ selectedPartnerId: id })),

  clear: () => set(() => ({ partners: null, selectedPartnerId: null })),
}));
